import type { ReactNode } from 'react';

export const symbol_sensor_door: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M230-90q-24.75 0-42.37-17.63Q170-125.25 170-150v-660q0-24.75 17.63-42.38Q205.25-870 230-870h500q24.75 0 42.38 17.62Q790-834.75 790-810v660q0 24.75-17.62 42.37Q754.75-90 730-90H230Zm0-60h500v-660H230v660Zm390.12-280q20.88 0 35.38-14.62 14.5-14.62 14.5-35.5 0-20.88-14.62-35.38-14.62-14.5-35.5-14.5-20.88 0-35.38 14.62-14.5 14.62-14.5 35.5 0 20.88 14.62 35.38 14.62 14.5 35.5 14.5ZM230-810v660-660Z"
		/>
	</svg>
);
